import { Menu } from '@mantine/core'
import type { ReactNode } from 'react'
import { colors } from 'settings/colors'
import { useScreenSize } from 'utils/useScreenSize'

type ResponsiveMenuItemProps = {
  onClick: () => void
  children: ReactNode
}

export const ResponsiveMenuItem = ({ onClick, children, ...rest }: ResponsiveMenuItemProps) => {
  const { isWideScreen } = useScreenSize()

  return (
    <Menu.Item
      {...rest}
      onClick={onClick}
      css={{
        fontSize: '15px',
        fontWeight: 500,
        backgroundColor: 'transparent',
        ...(isWideScreen
          ? {
              paddingTop: '6px',
              paddingBottom: '6px',
            }
          : {
              'display': 'flex',
              'alignItems': 'center',
              'height': '50px',
              'textDecoration': 'underline',
              'color': colors.blue800,
              'paddingLeft': '0',
              '&[data-hovered]': {
                backgroundColor: 'transparent',
              },
              '&[data-active]': {
                backgroundColor: 'transparent',
              },
            }),
      }}
    >
      {children}
    </Menu.Item>
  )
}
